// removed by extract-text-webpack-plugin
module.exports = {"containerClass":"styles__containerClass___VFYfk","box_padding":"styles__box_padding___1gMtp","loading_dash":"styles__loading_dash___acfWU","container_general_order":"styles__container_general_order___1Um0l","last_tds":"styles__last_tds___1gkE2","title":"styles__title___2Unfy","height_line":"styles__height_line___1gZ0L","sale_column":"styles__sale_column___HCO9T","title_line":"styles__title_line___1SyUM"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/components/GeneralViewOrders/styles.css
// module id = 3194
// module chunks = 0